import { useState, useEffect } from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function Layout() {
  const { user, isAdmin, isSuperUser, logout, apiClient } = useAuth()
  const [pendingCount, setPendingCount] = useState(0)

  useEffect(() => {
    if (!apiClient) return

    const fetchPendingCount = async () => {
      try {
        const res = await apiClient.getPendingVersionsCount()
        setPendingCount(res.count)
      } catch {
        // Ignore errors - badge just won't show
      }
    }

    fetchPendingCount()
    // Refresh count every 60 seconds
    const interval = setInterval(fetchPendingCount, 60000)

    // Listen for pending changes updates (e.g., after accept/reject)
    const handlePendingUpdate = () => fetchPendingCount()
    window.addEventListener('pendingChangesUpdated', handlePendingUpdate)

    return () => {
      clearInterval(interval)
      window.removeEventListener('pendingChangesUpdated', handlePendingUpdate)
    }
  }, [apiClient])

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{
        backgroundColor: 'var(--color-bg-secondary)',
        borderBottom: '1px solid var(--color-border)',
        padding: 'var(--spacing-md) var(--spacing-lg)',
        overflow: 'visible',
      }}>
        <div style={{
          maxWidth: '1800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-lg)' }}>
            <NavLink to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 'var(--spacing-sm)' }}>
              <img
                src="/logo.avif"
                alt="Violet Research Logo"
                style={{
                  height: '80px',
                  width: 'auto',
                  objectFit: 'contain',
                  display: 'block'
                }}
              />
              <h1 style={{ fontSize: 'var(--font-size-md)', margin: 0, color: 'var(--color-text-primary)' }}>
                Violet Research
              </h1>
            </NavLink>
            <nav style={{ display: 'flex', gap: 'var(--spacing-md)' }}>
              <NavLink
                to="/"
                style={({ isActive }) => ({
                  padding: 'var(--spacing-sm) var(--spacing-md)',
                  borderRadius: 'var(--radius-md)',
                  backgroundColor: isActive ? 'var(--color-bg-tertiary)' : 'transparent',
                  color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                  textDecoration: 'none',
                })}
                end
              >
                Views
              </NavLink>
              <NavLink
                to="/schema"
                style={({ isActive }) => ({
                  padding: 'var(--spacing-sm) var(--spacing-md)',
                  borderRadius: 'var(--radius-md)',
                  backgroundColor: isActive ? 'var(--color-bg-tertiary)' : 'transparent',
                  color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                  textDecoration: 'none',
                })}
              >
                Schema
              </NavLink>
              <NavLink
                to="/pending-changes"
                style={({ isActive }) => ({
                  padding: 'var(--spacing-sm) var(--spacing-md)',
                  borderRadius: 'var(--radius-md)',
                  backgroundColor: isActive ? 'var(--color-bg-tertiary)' : 'transparent',
                  color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--spacing-xs)',
                })}
              >
                Pending Changes
                {pendingCount > 0 && (
                  <span style={{
                    backgroundColor: 'var(--color-primary)',
                    color: '#fff',
                    fontSize: 'var(--font-size-xs)',
                    fontWeight: 600,
                    padding: '2px 6px',
                    borderRadius: '10px',
                    minWidth: '18px',
                    textAlign: 'center',
                  }}>
                    {pendingCount > 99 ? '99+' : pendingCount}
                  </span>
                )}
              </NavLink>
              {isSuperUser && (
                <NavLink
                  to="/migrations"
                  style={({ isActive }) => ({
                    padding: 'var(--spacing-sm) var(--spacing-md)',
                    borderRadius: 'var(--radius-md)',
                    backgroundColor: isActive ? 'var(--color-bg-tertiary)' : 'transparent',
                    color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                    textDecoration: 'none',
                  })}
                >
                  Migrations
                </NavLink>
              )}
            </nav>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
            <span style={{ color: 'var(--color-text-secondary)' }}>
              {user?.email || user?.['cognito:username'] || user?.name || user?.sub}
              {isAdmin && (
                <span className="badge badge-primary" style={{ marginLeft: 'var(--spacing-sm)' }}>
                  Admin
                </span>
              )}
              {isSuperUser && (
                <span className="badge" style={{ marginLeft: 'var(--spacing-sm)', backgroundColor: 'var(--color-warning)', color: '#000' }}>
                  SU
                </span>
              )}
            </span>
            <button className="btn btn-secondary" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
    </div>
  )
}
